import { useTranslation } from 'react-i18next';
import {
  COMPLETION_STRATEGY_OPTIONS,
  type SupplyAgentCompletionStrategy,
} from '@/modules/supply/components/supplyAgentRuleUtils';

interface SupplyAgentCompletionStrategyPickerProps {
  value: SupplyAgentCompletionStrategy;
  disabled?: boolean;
  compact?: boolean;
  onChange: (strategy: SupplyAgentCompletionStrategy) => void;
}

export function SupplyAgentCompletionStrategyPicker({
  value,
  disabled = false,
  compact = false,
  onChange,
}: SupplyAgentCompletionStrategyPickerProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-1">
      {COMPLETION_STRATEGY_OPTIONS.map((option) => {
        const selected = value === option.id;
        return (
          <button
            key={option.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.id)}
            className={`${
              compact ? 'rounded px-1.5 py-0.5 text-[10px]' : 'rounded-md px-2 py-1 text-[11px]'
            } font-medium transition-colors disabled:opacity-60 ${
              selected
                ? 'bg-indigo-700 text-white'
                : 'bg-white text-indigo-800 border border-indigo-200 hover:bg-indigo-100'
            }`}
          >
            {t(option.labelKey)}
          </button>
        );
      })}
    </div>
  );
}
